import { render, staticRenderFns } from "./DenyRxAuth.vue?vue&type=template&id=4ccbff28"
import script from "./DenyRxAuth.vue?vue&type=script&lang=js"
export * from "./DenyRxAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports